import { render, staticRenderFns } from "./GiftCodeWidgetCard.vue?vue&type=template&id=cfeb335e"
import script from "./GiftCodeWidgetCard.vue?vue&type=script&lang=js"
export * from "./GiftCodeWidgetCard.vue?vue&type=script&lang=js"
import style0 from "./GiftCodeWidgetCard.vue?vue&type=style&index=0&id=cfeb335e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports